import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=70c343ba&scoped=true&"
var script = {}
import style0 from "./NoData.vue?vue&type=style&index=0&id=70c343ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c343ba",
  null
  
)

export default component.exports